import type { BaseUsecase } from '@usecases/base-usecase';

export type RecordingToggleRequest = boolean;

export interface RecordingToggleEventPublisher {
  publish(onRecordStart: boolean): Promise<void>;
}

export interface RecordingToggleUsecase
  extends BaseUsecase<RecordingToggleRequest, void> {
  run(call: RecordingToggleRequest): Promise<void>;
}

export class RecordingToggle implements RecordingToggleUsecase {
  constructor(private publisher: RecordingToggleEventPublisher) {}

  async run(req: RecordingToggleRequest): Promise<void> {
    await this.publisher.publish(req);
  }
}
